<template>
    <tr
        class="convention-ca-activity-item"
        :class="isExcluded ? 'convention-ca-activity-item-excluded' : ''"
    >
        <td>
            <typo :name="isExcluded ? 'cc-body-italic' : 'cc-body'">{{ item.code }}</typo>
        </td>
        <td>
            <typo v-if="title" :name="isExcluded ? 'cc-body-italic' : 'cc-body'">{{ title }}</typo>
            <convention-body
                v-if="description"
                :body="description"
                :typoName="isExcluded ? 'cc-body-italic' : 'cc-body'"
            />
        </td>
    </tr>
</template>

<script>
import ConventionBody from "src/components/convention/ConventionBody.vue";

export default {
    components: { ConventionBody },
    props: ["item", "apenafs", "isExcluded"],
    computed: {
        title() {
            if (this.item.hideDefaultTitle) return null;
            const defaultTitle = this.apenafs[this.item.code].label;
            if (this.isExcluded && !this.item.description) {
                return `${defaultTitle} (exclu de l'extension)`;
            }
            return defaultTitle;
        },
        description() {
            if (!this.item.description) return null;
            if (this.isExcluded) {
                return `${this.item.description} (exclu de l'extension)`;
            }
            return this.item.description;
        },
    },
};
</script>

<style scoped lang="sass">
.convention-ca-activity-item-excluded
    font-style: italic
.col
    border: 1px solid $color-background
</style>
